import FormattedMessage from 'I18n/components/FormattedMessage';
import { NextActionModal } from 'growth-onboarding-next-action-components/NextActionModal';
import { THEME_EDITOR_URL, GLOBAL_HOME_URL } from '../utils/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const removeQueryParam = param => {
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  window.history.replaceState({}, '', url.toString());
};
export const UCAONextActionModal = ({
  onClose
}) => {
  const handleClose = () => {
    removeQueryParam('via');
    onClose();
  };
  return /*#__PURE__*/_jsx(NextActionModal, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "next-action-modal-customize-theme.title"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "next-action-modal-customize-theme.description"
    }),
    card: {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "next-action-modal-customize-theme.card.title"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "next-action-modal-customize-theme.card.description"
      }),
      button: {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "next-action-modal-customize-theme.card.button.text"
        }),
        href: THEME_EDITOR_URL
      }
    },
    footer: {
      button: {
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "next-action-modal-customize-theme.footer.button.text"
        }),
        href: GLOBAL_HOME_URL
      }
    },
    onClose: handleClose
  });
};